const request = {
    invalid_input: 'Input is invalid. {{details}}',
    general: 'Request error occurred.',
};
export default Object.freeze(request);
